module.exports = __webpack_public_path__ + "img/ats-logo.0873c03a.png";